<template>
  <div>
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <router-link class="navbar-item is-size-4 has-text-weight-bold" :to="'/'">
            Simple Manager
          </router-link>

          <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false"
            :class="{'is-active': menuActive}" @click="menuActive = !menuActive">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbarBasicExample" class="navbar-menu"  :class="{'is-active': menuActive}">
          <div class="navbar-start" v-if="token">
            <router-link class="navbar-item" :to="'/invoices'" v-if="groups && groups.includes('InvoiceUsers')">
              Invoices
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && groups.includes('PriceMonitorUsers')">
              <router-link class="navbar-link" :to="'/products'">
                Prices
              </router-link>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" :to="'/price-analysis'">
                  Price Analysis
                </router-link>
                <router-link class="navbar-item" :to="'/products'">
                  Products
                </router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && groups.includes('SalesUsers')">
              <a class="navbar-link">
                Sales
              </a>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" :to="'/sales-monitor'">
                  Sales monitor
                </router-link>
                <router-link class="navbar-item" :to="'/products-sales'">
                  Products
                </router-link>
              </div>
            </div>
            <router-link class="navbar-item" :to="'/products-landed-costs'" v-if="groups && groups.includes('SalesUsers')">
              Landed Costs
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && groups.includes('SalesUsers')">
              <router-link class="navbar-link" :to="'/forecast'">
                Forecast
              </router-link>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" :to="'/forecast'">
                  US
                </router-link>
                <router-link class="navbar-item" :to="'/forecast-canada'">
                  Canada
                </router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && (groups.includes('Vendors') || groups.includes('VendorAdmin'))">
              <a class="navbar-link" v-if="groups.includes('Vendors')">
                Vendor POs
              </a>
              <router-link class="navbar-link" :to="'/purchase-orders'" v-if="groups.includes('VendorAdmin')">
                POs
              </router-link>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" v-for="(v, i) in myVendors" :to="'/vendor-purchase-orders/' + v.nsId" :key="'mv1-' + i">
                  {{ v.entityId + ' ' + v.companyName }}
                </router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && (groups.includes('Vendors') || groups.includes('VendorAdmin'))">
              <a class="navbar-link" v-if="groups.includes('Vendors')">
                Vendor inbound shipments
              </a>
              <router-link class="navbar-link" :to="'/inbounds'" v-if="groups.includes('VendorAdmin')">
                Inbounds
              </router-link>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" v-for="(v, i) in myVendors" :to="'/vendor-inbounds/' + v.nsId" :key="'mv2-' + i">
                  {{ v.entityId + ' ' + v.companyName }}
                </router-link>
              </div>
            </div>
            <router-link class="navbar-item" :to="'/returned-items'" v-if="groups && groups.includes('ReturnsUsers')">
              Returns
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable" v-if="groups && groups.includes('ReturnsUsers')">
              <a class="navbar-link">
                CS
              </a>
              <div class="navbar-dropdown">
                <a class="navbar-item" href="https://cs-app-internal-only.vanityart.com" target="_blank">
                  Zoho reply
                </a>
              </div>
            </div>
          </div>

          <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable" v-if="staff || superuser">
              <a class="navbar-link">
                <span class="icon">
                  <i class="fas fa-cog"></i>
                </span>
              </a>
              <div class="navbar-dropdown">
                <a class="navbar-item" v-if="staff" target="_blank" :href="adminUrl">
                  <span>Database</span>
                </a>
                <hr class="navbar-divider">
                <router-link class="navbar-item" v-if="staff" :to="'/chat'">
                  <span>AI Chat</span>
                </router-link>
                <hr class="navbar-divider">
                <router-link class="navbar-item" v-if="staff" :to="'/my-config'">
                  <span>Config</span>
                </router-link>
                <router-link class="navbar-item" v-if="staff" :to="'/config-vendors'">
                  <span>Vendors</span>
                </router-link>
                <router-link class="navbar-item" v-if="staff" :to="'/config-accounts'">
                  <span>Accounts</span>
                </router-link>
                <router-link class="navbar-item" v-if="staff" :to="'/config-locations'">
                  <span>locations</span>
                </router-link>
                <router-link class="navbar-item" v-if="staff" :to="'/config-classes'">
                  <span>Classes</span>
                </router-link>
                <hr class="navbar-divider">
                <router-link class="navbar-item" v-if="superuser" :to="'/dev-tools'">
                  <span>Dev tools</span>
                </router-link>
              </div>
            </div>

            <a class="navbar-item" v-if="token" @click="signout">
              <span class="icon">
                <i class="fas fa-sign-out-alt"></i>
              </span>
              <span>Sign out</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Header',
  data () {
    return {
      menuActive: false
    }
  },
  computed: {
    token () {
      return this.$store.state.user.token
    },
    staff () {
      return this.$store.state.user.staff
    },
    superuser () {
      return this.$store.state.user.superuser
    },
    groups () {
      return this.$store.state.user.groups
    },
    routerPath () {
      return this.$route.path
    },
    server () {
      return this.$store.state.config.server
    },
    myVendors () {
      return this.$store.state.config.myVendors
    },
    adminUrl () {
      return this.server + '/admin'
    },
  },
  methods: {
    signout () {
      var confirm = {
        title: 'Sign Out',
        message: 'Are you sure to sign out?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.signoutConfirmed,
          args: []
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    signoutConfirmed () {
      delete Vue.http.headers.common['Authorization']
      this.$store.commit('user/reset')
      if (this.routerPath != '/') {
        this.$router.push('/')
      }
    },
    getVendorSubsidiary () {
      this.$http.get(this.server + '/myapp/get-vendor-subsidiaries/').then(resp => {
        this.$store.commit('config/setVendorSubsidiary', resp.body)
      })
    },
    getMyVendors () {
      this.$http.get(this.server + '/myapp/get-my-vendors/').then(resp => {
        this.$store.commit('config/setMyVendors', resp.body)
      })
    },
  },
  mounted () {
    if (this.token) {
      Vue.http.headers.common['Authorization'] = 'Token ' + this.token
      if (this.groups && this.groups.includes('InvoiceUsers')) {
        this.getVendorSubsidiary()
      }
      if (this.groups && (this.groups.includes('Vendors') || this.groups.includes('VendorAdmin'))) {
        this.getMyVendors()
      }
    }
  }
}
</script>